module.exports = __webpack_public_path__ + "media/images/light-mode-be222fba.png";